import { ReverseObject } from '@core/types/utils.types';
import { LinkProps } from '@stadionhq-v3/base-ui';

export const reverseObject = <T extends { [x: string]: string }>(obj: {
  [x: string]: string;
}): ReverseObject<T> =>
  Object.fromEntries(Object.entries(obj ?? {}).map((entry) => entry.reverse()));

export const renameKeyFromTitleToText = (someObj: LinkProps) => {
  const { title: oldKeyValue, ...rest } = someObj;
  return { ...rest, text: oldKeyValue };
};
